var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEinbruchBrandschutz = function SvgEinbruchBrandschutz(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 69.733,
    height: 88.814
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "einbruch-brandschutz_svg__e",
    x1: 21.642,
    x2: 20.324,
    y1: 82.987,
    y2: 9.173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e03616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.267,
    stopColor: "#ef6001"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335,
    stopColor: "#f17011"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.549,
    stopColor: "#f79f3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.739,
    stopColor: "#fbc15f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.896,
    stopColor: "#fed673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffdd7a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "einbruch-brandschutz_svg__f",
    x1: 28.024,
    x2: 11.974,
    y1: 76.362,
    y2: 16.854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e84b0b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#ef6001"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.591,
    stopColor: "#f3811d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#fed564"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fed766"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "einbruch-brandschutz_svg__g",
    x1: 42.997,
    x2: 29.903,
    y1: 44.65,
    y2: 58.306,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#59797f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a0b2b6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "einbruch-brandschutz_svg__h",
    x1: 35.074,
    x2: 27.626,
    y1: 38.7,
    y2: 58.775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "einbruch-brandschutz_svg__a",
    x1: 28.929,
    x2: 44.402,
    y1: 46.284,
    y2: 57.256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f4f4f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f4f4f8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#einbruch-brandschutz_svg__a",
    id: "einbruch-brandschutz_svg__i",
    x1: 31.983,
    x2: 40.406,
    y1: 41.404,
    y2: 48.049
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "einbruch-brandschutz_svg__b",
    x1: 4.77,
    x2: 14.235,
    y1: 41.731,
    y2: 43.118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#einbruch-brandschutz_svg__b",
    id: "einbruch-brandschutz_svg__j",
    x1: 56.758,
    x2: 62.547,
    y1: 50.767,
    y2: 51.615
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#einbruch-brandschutz_svg__b",
    id: "einbruch-brandschutz_svg__k",
    x1: 25.763,
    x2: 45.014,
    y1: 43.596,
    y2: 46.416
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#einbruch-brandschutz_svg__b",
    id: "einbruch-brandschutz_svg__l",
    x1: 10.606,
    x2: 28.957,
    y1: 41.805,
    y2: 44.494
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#einbruch-brandschutz_svg__b",
    id: "einbruch-brandschutz_svg__m",
    x1: 40.184,
    x2: 55.923,
    y1: 47.212,
    y2: 49.518
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "einbruch-brandschutz_svg__n",
    x1: 42.616,
    x2: 34.083,
    y1: 83.817,
    y2: 18.241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e03616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.457,
    stopColor: "#ef6001",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.595,
    stopColor: "#f48b2b",
    stopOpacity: 0.363
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765,
    stopColor: "#fab856",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.906,
    stopColor: "#fed370",
    stopOpacity: 0.132
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffdd7a",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#einbruch-brandschutz_svg__e",
    id: "einbruch-brandschutz_svg__p",
    x1: 47.385,
    x2: 46.127,
    y1: 82.76,
    y2: 12.313
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#einbruch-brandschutz_svg__f",
    id: "einbruch-brandschutz_svg__q",
    x1: 45.583,
    x2: 55.143,
    y1: 74.107,
    y2: 3.66
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "einbruch-brandschutz_svg__r",
    x1: 45.181,
    x2: 49.17,
    y1: 86.297,
    y2: 30.457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e03616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ef6001"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "einbruch-brandschutz_svg__c"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M60.613 37.449s3.352 20.1-6.341 24.444c3.592-9.138 2.399-24.656-5.758-36.587C37.484 10.906 40.243 0 40.243 0q-.264.164-.523.327c-3.295 2.567-11.26 10.744-3.039 25.266 3.673 6.485 4.842 12.318 4.347 17.58-.748 7.975-5.324 14.643-10.812 20.296-.077.08-.142.165-.218.245-.339.36-.67.725-.979 1.103-.147.18-.277.37-.417.553-.221.29-.445.578-.649.876-.144.21-.271.428-.406.643-.178.281-.358.56-.52.848-.13.23-.244.463-.364.696-.145.28-.29.56-.421.844-.111.243-.21.489-.31.734-.116.281-.231.562-.333.846-.091.252-.17.506-.25.761-.089.28-.175.56-.25.843q-.102.39-.187.784-.095.417-.168.835-.07.399-.121.798-.054.413-.089.825-.035.404-.052.805-.015.406-.012.81c.002.27.005.537.02.804.013.267.038.53.064.794.027.266.053.532.092.795.039.26.09.515.142.771.052.262.1.523.166.78.063.252.143.498.218.746.078.253.15.508.24.757.09.246.199.484.301.724s.196.483.31.717c.123.248.266.484.403.725.12.215.23.435.363.644a15 15 0 0 0 2.039 2.513 47.4 47.4 0 0 0 7.186.718c7.877.202 15.627-3.295 21.705-8.726 12.51-11.173 17.948-30.525 2.894-42.631"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "einbruch-brandschutz_svg__d"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M19.47-5h55.263v98.814H19.47z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "einbruch-brandschutz_svg__o",
    width: 55.68,
    height: 99.36,
    x: 19.35,
    y: -5.139,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#einbruch-brandschutz_svg__c)",
    opacity: 0.99
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#einbruch-brandschutz_svg__d)"
  }, /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHQAAADPCAYAAAAkl/WRAAAACXBIWXMAABcRAAAXEQHKJvM/AAAB8ElEQVR4Xu3RMREAIBDAMMC/50cCM71k7tY9M7PIOK+AvxgaY2iMoTGGxhgaY2iMoTGGxhgaY2iMoTGGxhgaY2iMoTGGxhgaY2iMoTGGxhgaY2iMoTGGxhgaY2iMoTGGxhgaY2iMoTGGxhgaY2iMoTGGxhgaY2iMoTGGxhgaY2iMoTGGxhgaY2iMoTGGxhgaY2iMoTGGxhgaY2iMoTGGxhgaY2iMoTGGxhgaY2iMoTGGxhgaY2iMoTGGxhgaY2iMoTGGxhgaY2iMoTGGxhgaY2iMoTGGxhgaY2iMoTGGxhgaY2iMoTGGxhgaY2iMoTGGxhgaY2iMoTGGxhgaY2iMoTGGxhgaY2iMoTGGxhgaY2iMoTGGxhgaY2iMoTGGxhgaY2iMoTGGxhgaY2iMoTGGxhgaY2iMoTGGxhgaY2iMoTGGxhgaY2iMoTGGxhgaY2iMoTGGxhgaY2iMoTGGxhgaY2iMoTGGxhgaY2iMoTGGxhgaY2iMoTGGxhgaY2iMoTGGxhgaY2iMoTGGxhgaY2iMoTGGxhgaY2iMoTGGxhgaY2iMoTGGxhgaY2iMoTGGxhgaY2iMoTGGxhgaY2iMoTGGxhgaY2iMoTGGxhgaY2iMoTGGxhgaY2iMoTGGxhgaY2iMoTGGxhgaY2iMoTGGxhgacwH64wWa6hsR0AAAAABJRU5ErkJggg==",
    width: 116,
    height: 207,
    transform: "matrix(.48 0 0 .48 19.35 -5.14)"
  })))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Ebene 2",
    style: {
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#einbruch-brandschutz_svg__e)",
    d: "M30.657 62.292c-7.343 7.566-8.18 19.24-1.455 25.796C8.48 84.371-3.185 67.394.762 42.505c1.723 6.895 1.342 11.107 10.34 19.53C4.522 49.04-2.955 29.793 26.975 5.74c-1.871 4.504-4.018 13.68 4.328 22.025a94.4 94.4 0 0 1 10.682 13.26c-.783 8.356-5.577 15.343-11.328 21.266"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#einbruch-brandschutz_svg__f)",
    d: "M30.658 62.292c-6.63 7.313-8.045 17.768-2.647 24.483C9.98 82.945.065 68.763 1.14 48.877c1.092 4.113 2.941 8.038 9.236 13.93a1.07 1.07 0 0 0 .727.287 1.06 1.06 0 0 0 .943-1.536c-3.513-6.94-6.63-14.577-5.649-23.406 1.007-9.043 4.524-15.215 12.702-23.53a1.378 1.378 0 0 1 2.347.818c.519 3.889 4.095 7.29 9.106 13.074 3.195 3.69 9.943 10.216 10.399 14.544.16 1.522-.72 8.677-10.294 19.234"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#bcc8cc",
    d: "M35.903 88.475S50.456 76.16 55.665 69.997c7.434-8.789 11.136-35.396 8.97-46.684l-28.732-7.875L7.17 23.322c-2.166 11.28 1.536 37.886 8.97 46.675 5.21 6.164 19.763 18.478 19.763 18.478"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#4c6f73",
    d: "M35.407 81.471c-4.384-3.84-12.222-10.855-15.463-14.679-5.361-6.34-9.112-27.092-8.309-39.004l.036-.533 24.231-6.652 24.232 6.643.036.533c.803 11.91-2.948 32.661-8.308 39-3.46 4.096-11.968 11.64-15.465 14.693l-.495.433Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#a0b2b6",
    d: "M35.903 80.906c-5-4.38-12.296-10.956-15.386-14.6-5.256-6.216-8.911-26.901-8.132-38.467l23.518-6.456L59.42 27.83c.78 11.566-2.88 32.25-8.132 38.465C48.196 69.953 40.9 76.54 35.903 80.906"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#einbruch-brandschutz_svg__g)",
    d: "M44.884 47.18h-1.56v-3.36a7.425 7.425 0 0 0-14.842 0v3.36H26.92a1.34 1.34 0 0 0-1.344 1.34v10.994a1.344 1.344 0 0 0 1.344 1.344h17.963a1.344 1.344 0 0 0 1.344-1.344V48.52a1.34 1.34 0 0 0-1.344-1.34m-4.038 0h-9.887v-3.36a4.95 4.95 0 0 1 9.887 0Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#einbruch-brandschutz_svg__h)",
    d: "M26.642 60.336V49.342a1.34 1.34 0 0 1 1.343-1.341h1.562v-3.359a7.31 7.31 0 0 1 7.421-7.17 7.56 7.56 0 0 1 4.067 1.177 7.53 7.53 0 0 0-5.131-2 7.31 7.31 0 0 0-7.422 7.172v3.358H26.92a1.34 1.34 0 0 0-1.344 1.341v10.994a1.34 1.34 0 0 0 1.165 1.33 1.3 1.3 0 0 1-.1-.508"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#einbruch-brandschutz_svg__a)",
    d: "M35.903 37.06a6.896 6.896 0 0 1 7.009 6.76v3.769h1.972a.933.933 0 0 1 .932.932v10.993a.933.933 0 0 1-.932.932H26.922a.933.933 0 0 1-.933-.932V48.52a.933.933 0 0 1 .933-.932h1.972V43.82a6.896 6.896 0 0 1 7.009-6.762m0-.41a7.307 7.307 0 0 0-7.42 7.172v3.357h-1.561a1.343 1.343 0 0 0-1.344 1.343v10.993a1.343 1.343 0 0 0 1.344 1.343h17.962a1.343 1.343 0 0 0 1.343-1.343V48.52a1.343 1.343 0 0 0-1.343-1.343h-1.562v-3.357a7.307 7.307 0 0 0-7.42-7.172"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#einbruch-brandschutz_svg__i)",
    d: "M35.904 39.125a4.83 4.83 0 0 1 4.942 4.696v3.358h-9.887v-3.358a4.83 4.83 0 0 1 4.945-4.696m0-.376a5.206 5.206 0 0 0-5.32 5.072v3.734h10.638v-3.734a5.205 5.205 0 0 0-5.318-5.072"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#einbruch-brandschutz_svg__b)",
    d: "M11.54 32.516c-1.877-.456-3.56-.877-4.982-1.24a101.7 101.7 0 0 0 2.61 21.816q2.481-.722 4.846-1.239a99 99 0 0 1-2.473-19.337",
    style: {
      mixBlendMode: "soft-light"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#einbruch-brandschutz_svg__j)",
    d: "M59.71 40.527a89.7 89.7 0 0 1-4.049 18.794 46 46 0 0 1 4.073 3.33 88.6 88.6 0 0 0 4.999-22.164c-1.566.08-3.249.09-5.022.04",
    style: {
      mixBlendMode: "soft-light"
    }
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#f4f4f8",
    d: "m20.671 67.618-.125-.138c-.213-.238-.418-.47-.602-.688-5.361-6.34-9.112-27.092-8.309-39.004l.036-.533 23.178-6.363-23.327 5.82-.386.105-.027.4-.036.533c-.81 12.012 3.001 32.974 8.44 39.406a56 56 0 0 0 5.005 4.39c-1.474-1.426-2.807-2.778-3.847-3.928"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#einbruch-brandschutz_svg__k)",
    d: "M45.662 47.43a1.33 1.33 0 0 0-.778-.252h-1.56v-3.357a6.93 6.93 0 0 0-1.12-3.756 343 343 0 0 1-10.856-1.882 7.2 7.2 0 0 0-1.516 1.527 6.96 6.96 0 0 0-1.35 4.11v3.358h-1.56a1.344 1.344 0 0 0-1.345 1.342v.727a56 56 0 0 1 1.74-.03 49.5 49.5 0 0 1 18.91 3.608V48.52a1.34 1.34 0 0 0-.565-1.09m-4.816-.25h-9.887v-3.36a4.5 4.5 0 0 1 .598-2.236 4.8 4.8 0 0 1 1.584-1.656 5 5 0 0 1 .84-.434 5.19 5.19 0 0 1 3.845 0 5 5 0 0 1 .84.434 4.8 4.8 0 0 1 1.583 1.656 4.5 4.5 0 0 1 .597 2.237Z",
    opacity: 0.5,
    style: {
      mixBlendMode: "soft-light"
    }
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#einbruch-brandschutz_svg__l)",
    d: "M25.577 48.52a1.344 1.344 0 0 1 1.344-1.342h1.56v-3.357a6.96 6.96 0 0 1 1.35-4.111 7.4 7.4 0 0 1 2.167-1.968c-7.32-1.393-14.272-2.964-19.675-4.264a100.5 100.5 0 0 0 2.264 17.49 64 64 0 0 1 10.99-1.345Z",
    style: {
      mixBlendMode: "soft-light"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#einbruch-brandschutz_svg__m)",
    d: "M41.75 39.433c.12.15.244.298.352.457a6.96 6.96 0 0 1 1.221 3.93v3.358h1.56a1.35 1.35 0 0 1 1.345 1.342v4.68a47 47 0 0 1 9.056 4.924 91 91 0 0 0 3.577-16.876 154 154 0 0 1-17.111-1.815",
    style: {
      mixBlendMode: "soft-light"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#einbruch-brandschutz_svg__n)",
    d: "M59.734 62.65a65 65 0 0 0 2.456-7.724l.001-.007q.351-1.372.664-2.787l.011-.054c.413-1.869.774-3.779 1.083-5.697l.017-.102q.222-1.389.406-2.776l.032-.242c1.011-7.716 1.144-15.192.23-19.948l-28.731-7.875L7.17 23.322a49.5 49.5 0 0 0-.57 10.402l.004.101q.04 1.223.12 2.494l.015.224c.111 1.72.273 3.491.484 5.287l.014.129q.16 1.352.358 2.715l.017.114c.267 1.837.584 3.676.947 5.488l.021.106c1.64 8.13 4.223 15.67 7.56 19.615 5.21 6.164 19.763 18.478 19.763 18.478S50.456 76.16 55.665 69.997a27 27 0 0 0 4.069-7.346Z",
    opacity: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#einbruch-brandschutz_svg__o)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#einbruch-brandschutz_svg__p)",
    d: "M57.719 80.08c-6.078 5.43-13.828 8.928-21.705 8.726a47.4 47.4 0 0 1-7.186-.718c-6.419-6.256-5.62-17.398 1.388-24.619 5.488-5.653 10.064-12.32 10.812-20.296.495-5.262-.674-11.095-4.347-17.58-8.22-14.522-.256-22.699 3.04-25.266.171-.108.346-.22.522-.327 0 0-2.76 10.906 8.271 25.306 8.157 11.93 9.35 27.45 5.758 36.587 9.693-4.343 6.341-24.444 6.341-24.444 15.054 12.106 9.616 31.458-2.894 42.63"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#einbruch-brandschutz_svg__q)",
    d: "M57.047 79.325c-6.119 5.468-13.36 8.48-20.384 8.48q-.31 0-.624-.01a46 46 0 0 1-7.031-.7q-.667-.121-1.317-.26c-5.152-6.409-4.036-16.607 2.526-23.366 5.257-5.414 10.2-11.85 11.816-20.202 1.116-5.764-.953-11.96-4.47-18.173-6.776-11.961-2.167-19.32 1.374-22.75-.202 4.162.62 12.922 8.757 23.555a43.9 43.9 0 0 1 7.102 18.881c.825 6.176.29 12.277-1.466 16.742a1.01 1.01 0 0 0 .944 1.381 1 1 0 0 0 .41-.088c8.158-3.655 7.824-17.024 7.261-22.836a21.56 21.56 0 0 1 6.77 15.145c.218 8.433-4.145 17.482-11.668 24.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#einbruch-brandschutz_svg__r)",
    d: "M37.562 25.094c3.518 6.212 5.587 12.409 4.471 18.173-1.615 8.351-6.559 14.788-11.816 20.202-6.562 6.76-7.678 16.957-2.526 23.366.434.094.872.178 1.317.26a46 46 0 0 0 7.032.7q.313.01.623.01c7.025 0 14.265-3.012 20.384-8.48 7.523-6.719 11.886-15.768 11.667-24.201 0 0-4.663 17.57-20.271 17.57s-2.007-15.718-.867-20.984c3.642-16.821-10.014-26.616-10.014-26.616",
    opacity: 0.99
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e03616",
    d: "M25.319 71.662a20.1 20.1 0 0 1 3.509-7.002c.815-1.05 1.757-1.964 2.604-2.941a61 61 0 0 0 2.5-2.983 36.9 36.9 0 0 0 7.143-13.586 18.4 18.4 0 0 0 .636-7.56 29.8 29.8 0 0 0-2.049-7.41 46 46 0 0 0-1.614-3.531c-.584-1.151-1.241-2.295-1.781-3.497a23.1 23.1 0 0 1-2.06-7.558 24.5 24.5 0 0 0 2.507 7.344c.578 1.157 1.258 2.259 1.898 3.412a46 46 0 0 1 1.766 3.527 27.7 27.7 0 0 1 2.246 7.596 19.7 19.7 0 0 1 .131 4.002 21.4 21.4 0 0 1-.705 3.934 36.5 36.5 0 0 1-7.517 13.815A62 62 0 0 1 31.9 62.15c-.899.96-1.862 1.842-2.69 2.822a21.1 21.1 0 0 0-3.891 6.69"
  })))));
};
export default SvgEinbruchBrandschutz;